import { render, staticRenderFns } from "./SavedSearchEditAlertDialog.vue?vue&type=template&id=3800d5a0&scoped=true"
import script from "./SavedSearchEditAlertDialog.vue?vue&type=script&lang=js"
export * from "./SavedSearchEditAlertDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3800d5a0",
  null
  
)

export default component.exports